module.exports = __webpack_public_path__ + "img/9788901094809.d480c536.jpg";